import { signOut } from 'aws-amplify/auth'
import React, { useEffect } from 'react'
import { useRecoilState } from 'recoil'
import analytics, { EVENTS } from 'src/utils/analytics'
import posthog from 'posthog-js'
import { authContext, getStoredUserAuth } from 'src/utils/auth/auth-context'
import useControlPlaneApi from 'src/utils/hooks/use-control-plane-api'
import { UserData, userState } from 'src/utils/state'
import { LogoutUserDocument } from '@vendia/control-plane-api'

export default function LogoutPage() {
  const { setUnauthStatus } = React.useContext(authContext)
  const [_user, setUserState] = useRecoilState(userState)
  const client = useControlPlaneApi()

  useEffect(() => {
    analytics.track(EVENTS.USER_SIGN_OUT)
    posthog.reset()

    const performLogout = async () => {
      try {
        await client.graphqlFetch({ query: LogoutUserDocument })
      } catch (error) {
        console.error('Error calling logoutUser:', error)
      }

      const session = getStoredUserAuth()

      const cleanUp = () => {
        setUnauthStatus()
        setUserState({} as UserData)
        // Clear all non-enterprise redirect flags for any user
        Object.keys(sessionStorage).forEach((key) => {
          if (key.startsWith('non_enterprise_initial_redirect_')) {
            sessionStorage.removeItem(key)
          }
        })
        window.location.href = '/login'
      }

      if (session.type === 'COGNITO') {
        signOut().then(cleanUp)
      } else {
        cleanUp()
      }
    }

    performLogout()
  }, [])

  return null
}
